import { useState, useEffect } from "react";
import * as Scrivito from "scrivito";

function AddressToLocation({ widget }) {
  const [address, setAddress] = useState(widget.get("address") || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setAddress(widget.get("address") || "");
  }, [widget]);

  const fetchLocation = async () => {
    if (!address.trim()) {
      setError("Please enter an address.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(
          address
        )}`,
        {
          headers: {
            "Accept-Language": "de",
          },
        }
      );
      const data = await response.json();

      if (!data || data.length === 0) {
        setError("No coordinates found for this address.");
        return;
      }

      const lat = parseFloat(data[0].lat);
      const lon = parseFloat(data[0].lon);

      if (Number.isNaN(lat) || Number.isNaN(lon)) {
        setError("Invalid geocoordinates received.");
        return;
      }

      await widget.update({
        address: address.trim(),
        lat,
        lon,
      });
    } catch (err) {
      console.error("AddressToLocation geocoding failed", err);
      setError(`Error fetching address. Please try again later.<br />${err}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="address-to-location p-3">
      <div className="mb-2">
        <label className="form-label" htmlFor="osm-address-input">
          Address for OpenStreetMap Marker
        </label>
        <input
          id="osm-address-input"
          type="text"
          className="form-control"
          value={address}
          onChange={(event) => setAddress(event.target.value)}
          placeholder="e.g., Heilbronn, Germany"
        />
      </div>
      <button
        type="button"
        className="btn btn-primary"
        onClick={fetchLocation}
        disabled={loading}
      >
        {loading ? "Fetching coordinates…" : "Fetch Coordinates"}
      </button>
      {error && <div className="text-danger mt-2">{error}</div>}
      <div className="mt-2 small text-muted">
        Actual values: lat={widget.get("lat") || "-"}, lon=
        {widget.get("lon") || "-"}
      </div>
    </div>
  );
}

const ConnectedAddressToLocation = Scrivito.connect(AddressToLocation);
Scrivito.registerComponent(
  "AddressToLocation",
  Scrivito.connect(ConnectedAddressToLocation)
);

export default ConnectedAddressToLocation;
